import { useMemo } from 'react';
import { VersionedFeatureType } from '../../../../../../../data-access/gql-types/graphql';
import { useCheckDeviceSupport } from '../../../../../hooks/version-map/use-check-device-support';
import { ChannelType } from '../../../../../types';

export const useOptimizerSupport = (channel: ChannelType) => {
  const { checkSupport, versionMap } = useCheckDeviceSupport();

  const tariffSupported = useMemo(
    () =>
      checkSupport({
        feature: VersionedFeatureType.OptimizerTariffs,
        supportKey: 'Optimizer',
        currentVersion: channel.currentFirmwareVersion,
      }),
    [channel.currentFirmwareVersion, versionMap],
  );

  return {
    tariffSupported,
  };
};
